/**
 * Shared DDL schemas for analytics dashboard.
 * These schemas are used by both the client (the analytics lake's views)
 * and server (for transforming data to match the schema).
 */
export const STRADA_CALLS_DDL = `
  CREATE TABLE IF NOT EXISTS strada_calls_history (
    call_id text NOT NULL PRIMARY KEY,
    agent_id text NOT NULL,
    agent_name text,
    created_at text NOT NULL,
    status text NOT NULL,
    type text,
    campaign_name text,
    started_at text,
    recording_url text,
    ended_at text,
    customer_number text,
    ended_reason text,
    transfer_destination text,
    summary text,
    analysis jsonb,
    transcript jsonb,
    call_variables jsonb,
    session_variables jsonb,
    phone_number text,
    campaign_parent_call_ids jsonb,
    is_connected boolean NOT NULL DEFAULT false,
    is_converted boolean NOT NULL DEFAULT false,
    is_test boolean NOT NULL DEFAULT false,
    ended_by text,
    qa_sentiment text,
    rubric_results jsonb,
    rubric_outcomes jsonb,
    external_id text,
    sip_headers jsonb
  );
`;
export const STRADA_CHATS_DDL = `
  CREATE TABLE IF NOT EXISTS strada_chats_history (
    chat_id text NOT NULL PRIMARY KEY,
    agent_id text NOT NULL,
    customer_unique_id text,
    agent_name text,
    created_at text NOT NULL,
    handed_off_at text,
    terminated_at text,
    abandoned_at text,
    status text NOT NULL,
    summary text,
    analysis jsonb,
    transcript jsonb,
    chat_variables jsonb,
    session_variables jsonb,
    metadata jsonb,
    secure_metadata_keys jsonb,
    is_test boolean NOT NULL DEFAULT false,
    qa_sentiment text,
    rubric_results jsonb,
    rubric_outcomes jsonb,
    csat boolean
  );
`;
export const STRADA_EMAILS_DDL = `
  CREATE TABLE IF NOT EXISTS strada_emails_history (
    thread_id text NOT NULL PRIMARY KEY,
    agent_id text,
    agent_name text,
    channel_type text,
    channel_email_address text,
    customer_email text,
    subject text,
    created_at text NOT NULL,
    latest_message_at text,
    message_count integer,
    actions_used jsonb,
    action_apps jsonb,
    is_test boolean NOT NULL DEFAULT false,
    has_feedback boolean NOT NULL DEFAULT false,
    has_attachment boolean NOT NULL DEFAULT false,
    session_variables jsonb
  );
`;
export const COMBINED_DDL = `${STRADA_CALLS_DDL}\n${STRADA_CHATS_DDL}\n${STRADA_EMAILS_DDL}`;
//# sourceMappingURL=analytics-schemas.js.map